import { extends as _extends, objectWithoutProperties as _objectWithoutProperties, objectSpread2 as _objectSpread2 } from '../../../../_virtual/_rollupPluginBabelHelpers.esm.js';
import React, { useContext, forwardRef } from 'react';
import { useObjectRef } from 'react-aria';
import { DragAndDropContext } from 'react-aria-components';
import { useRenderProps } from '../../../utils/index.esm.js';

var _excluded = ["dropIndicatorProps", "isDropTarget"];
function ListBoxDropIndicatorWrapper(props, ref) {
  ref = useObjectRef(ref);
  var _ref = useContext(DragAndDropContext),
    dragAndDropHooks = _ref.dragAndDropHooks,
    dropState = _ref.dropState;
  var _ref2 = dragAndDropHooks.useDropIndicator(props, dropState, ref),
    dropIndicatorProps = _ref2.dropIndicatorProps,
    isHidden = _ref2.isHidden,
    isDropTarget = _ref2.isDropTarget;
  if (isHidden) {
    return null;
  }
  return /*#__PURE__*/React.createElement(ListBoxDropIndicatorForwardRef, _extends({}, props, {
    dropIndicatorProps: dropIndicatorProps,
    isDropTarget: isDropTarget,
    ref: ref
  }));
}
function ListBoxDropIndicator(props, ref) {
  var dropIndicatorProps = props.dropIndicatorProps,
    isDropTarget = props.isDropTarget,
    otherProps = _objectWithoutProperties(props, _excluded);
  var renderProps = useRenderProps(_objectSpread2(_objectSpread2({}, otherProps), {}, {
    defaultClassName: 'react-aria-DropIndicator',
    values: {
      isDropTarget: isDropTarget
    }
  }));
  return /*#__PURE__*/React.createElement("div", _extends({}, dropIndicatorProps, renderProps, {
    // eslint-disable-next-line
    role: "option",
    ref: ref,
    "data-drop-target": isDropTarget || undefined
  }));
}
var ListBoxDropIndicatorForwardRef = /*#__PURE__*/forwardRef(ListBoxDropIndicator);

export { ListBoxDropIndicatorWrapper, ListBoxDropIndicator as default };
//# sourceMappingURL=list-box-drop-indicator.esm.js.map
